import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Container, TitleWrapper, Input, Text, IconWrapper, BoxWrapper, ButtonAsync } from '../design';
import courseRequests from 'services/course';
import adminRequests from 'services/admin';
import { message } from 'shell/components';

import icEdit from 'utils/assetFiles/svgs/icEdit';
import { useContext } from 'react';
import { PageContext } from '../PageProvider';

const GridWrapper = styled.div`
    display: grid;
    grid-template-rows: repeat(3, auto);
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 10px;
`;

const SubmitBtnWrapper = styled.div`
    grid-row: 1/4;
    grid-column: 3/4;
    justify-self: end;
    align-self: end;
`;

const CourseDetail = ({ complete, onSubmit, onEdit }) => {
    const { setReviewData } = useContext(PageContext);
    const [submitDisabled, setSubmitDisabled] = useState(true);

    const [school, setSchool] = useState('');
    const [faculty, setFaculty] = useState('');
    const [name, setName] = useState('');
    const [section, setSection] = useState('');
    const [semester, setSemester] = useState('');

    const getFinalData = () => {
        return { school, faculty, name, section, semester };
    };

    const handleClickEdit = () => {
        onEdit();
    };

    const handleSubmitRequest = async () => {
        const data = getFinalData();
        return adminRequests.findCourse(data);
    };

    const handleSubmitSuccess = (data) => {
        if (data) {
            message.error('The course already exist');
            return;
        }
        setReviewData((prev) => ({ ...prev, course: getFinalData() }));
        onSubmit();
    };

    useEffect(() => {
        if (school && faculty && name && section && semester) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [school, faculty, name, section, semester]);

    return (
        <Container complete={complete}>
            <TitleWrapper complete={complete}>
                Course Details
                {complete !== false && <IconWrapper onClick={handleClickEdit}>{icEdit}</IconWrapper>}
            </TitleWrapper>

            <BoxWrapper complete={complete}>
                <GridWrapper>
                    <div>
                        <Text required>SCHOOL</Text>
                        <Input id={'au_school'} value={school} onChange={(e) => setSchool(e.target.value)} />
                    </div>

                    <div>
                        <Text required>FACULTY</Text>
                        <Input id={'au_faculty'} value={faculty} onChange={(e) => setFaculty(e.target.value)} />
                    </div>

                    <div>
                        <Text style={{ marginBottom: 5 }} required>
                            COURSE
                        </Text>
                        <Input id={'au_course'} value={name} onChange={(e) => setName(e.target.value)} />
                    </div>

                    <div>
                        <Text style={{ marginBottom: 5 }} required>
                            SECTION
                        </Text>
                        <Input id={'au_section'} value={section} onChange={(e) => setSection(e.target.value)} />
                    </div>

                    <div>
                        <Text style={{ marginBottom: 5 }} required>
                            SEMESTER
                        </Text>
                        <Input id={'au_semester'} value={semester} onChange={(e) => setSemester(e.target.value)} />
                    </div>

                    <div />

                    <SubmitBtnWrapper id={'au_courseNext'}>
                        <ButtonAsync
                            disabled={submitDisabled}
                            onClick={handleSubmitRequest}
                            onSuccess={handleSubmitSuccess}
                        />
                    </SubmitBtnWrapper>
                </GridWrapper>
            </BoxWrapper>
        </Container>
    );
};

export default CourseDetail;
